"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var React = tslib_1.__importStar(require("react"));

var async_1 = require("@shopify/async");

var Async_1 = require("./Async");

function createAsyncContext(_a) {
  var id = _a.id,
      load = _a.load;
  var Context = React.createContext(null);

  function Provider(props) {
    return React.createElement(Async_1.Async, {
      load: load,
      id: id,
      render: function render(value) {
        return React.createElement(Context.Provider, tslib_1.__assign({
          value: value
        }, props));
      }
    });
  }

  function Consumer(props) {
    return React.createElement(Context.Consumer, tslib_1.__assign({}, props));
  }

  function Preload() {
    return React.createElement(Async_1.Async, {
      defer: async_1.DeferTiming.Idle,
      load: load
    });
  }

  return {
    Context: Context,
    Provider: Provider,
    Consumer: Consumer,
    Preload: Preload
  };
}

exports.createAsyncContext = createAsyncContext;